export const getIndicatorTooltip = (indicator: number): string => {
  if (indicator === 0) return "Global warming potential";
  if (indicator === 1) return "Ozone depletion potential";

  if (indicator === 2) return "Acidification potential";

  if (indicator === 3) return "Eutrophication potential";

  if (indicator === 4) return "Photochemical ozone creation potential";

  if (indicator === 5) return "Abiotic depletion potential - non-fossil resources";
  if (indicator === 6) return "Abiotic depletion potential - fossil fuels";
  if (indicator === 7) return "Human Toxicity Potentia";
  if (indicator === 8) return "Freshwater Aquatic Ecotoxicity Potential";
  if (indicator === 9) return "Terestial Ecotoxicity Potential";
  if (indicator === 10) return "Environmental Cost Indicator";
  if (indicator === 11) return "Marine Aquatic Ecotoxicitty Potential";
  if (indicator === 12) return "Global warming potential - total";

  if (indicator === 13) return "Global Warming Potential - biogenic";
  if (indicator === 14) return "Global Warming Potential - fossil fuels";

  if (indicator === 15) return "Renewable primary energy excluding resources used as raw materials";

  if (indicator === 16) return "Renewable primary energy resources used as raw materials";

  if (indicator === 17) return "Renewable primary energy resources";

  if (indicator === 18) return "Non-renewable primary energy excluding resources used as raw materials";

  if (indicator === 19) return "Non-renewable primary energy resources used as raw materials";

  if (indicator === 20) return "Non-renewable primary energy resources";

  if (indicator === 21) return "Use of secondary material";

  if (indicator === 22) return "Renewable secondary fuels";

  if (indicator === 23) return "Non-renewable secondary fuels";

  if (indicator === 24) return "Net use of fresh water";

  if (indicator === 25) return "Hazardous waste disposed";

  if (indicator === 27) return "Radioactive waste disposed";

  if (indicator === 28) return "Components for re-use";

  if (indicator === 29) return "Materials for recycling";
  if (indicator === 30) return "Materials for energy recovery";

  if (indicator === 31) return "Exported energi, electricity";

  if (indicator === 32) return "Exported energi, thermal";

  if (indicator === 33) return "Non-hazardous waste disposed";

  if (indicator === 34) return "Eutrophication – aquatic freshwater";
  if (indicator === 35) return "Eutrophication – terrestrial";
  if (indicator === 36) return "Eutrophication – aquatic marine";

  if (indicator === 37) return "Eco toxicity – freshwater";
  if (indicator === 38) return "Human toxicity – cancer effects";
  if (indicator === 39) return "Human toxicity – non cancer effects";
  if (indicator === 40) return "Abiotic Depletion Potential – minerals and metals";
  if (indicator === 41) return "Abiotic Depletion Potential – fossil fuels";

  if (indicator === 42) return "Global Warming Potential - land use and land use change;";

  if (indicator === 44) return "Water deprivation potential";

  if (indicator === 45) return "Particulate matter emissions";

  if (indicator === 46) return "Ionizing radiation - human health";

  if (indicator === 47) return "Soil quality";

  if (indicator === 48) return "Exported energy";
  if (indicator === 49) return "Eutrophication – aquatic freshwater";

  if (indicator === 51) return "Ionizing radiation";
  if (indicator === 52) return "Human toxicity – cancer effects";
  if (indicator === 53) return "Human toxicity – non cancer effects";

  if (indicator === 55) return "Surplus ore potential";

  return "";
};
